/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  var MOBILE_BREAKPOINT = 799;
  var swiperInstances = {};

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initSwiper(sectionId) {
    var $section = $('#shopify-section-' + sectionId);
    var $slider = $section.find('.reviews-text__slider');
    if (!$slider.length || swiperInstances[sectionId]) return;

    swiperInstances[sectionId] = new Swiper($slider[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
       grabCursor: true,
    speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 5,
    followFinger: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    nested: true,
    edgeSwipeDetection: true,
    edgeSwipeThreshold: 20,
    watchSlidesProgress: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      sticky: false,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        nextEl: $slider.find('.reviews-text__btn--next')[0],
        prevEl: $slider.find('.reviews-text__btn--prev')[0]
      }
    });
  }

  function destroySwiper(sectionId) {
    if (swiperInstances[sectionId]) {
      swiperInstances[sectionId].destroy(true, true);
      delete swiperInstances[sectionId];
    }
  }

  function applyGrid(sectionId) {
    var $section = $('#shopify-section-' + sectionId);
    var $slider = $section.find('.reviews-text__slider');
    var $wrapper = $slider.find('.swiper-wrapper');
    var $cards = $section.find('.reviews-text__card');
    var $nav = $section.find('.reviews-text__nav');
    var showMoreText = $wrapper.data('show-more');
    var showLessText = $wrapper.data('show-less');
    var visible = 4;

    $slider.addClass('reviews-text__slider--grid');
    $slider.removeClass('active');

    $cards.each(function (i) {
      $(this).toggleClass('reviews-text__card--hidden', i >= visible);
    });

    var $existingBtn = $nav.find('.reviews-text__toggle');
    if ($existingBtn.length) {
      $existingBtn.text(showMoreText);
      return;
    }

    if ($cards.length > visible) {
      var $btn = $('<button type="button" class="reviews-text__toggle desk_primary-btn">' + showMoreText + '</button>');
      $nav.prepend($btn);

      $btn.on('click', function () {
        var $hidden = $section.find('.reviews-text__card--hidden');
        if ($hidden.length) {
          $hidden.removeClass('reviews-text__card--hidden');
          $btn.text(showLessText);
          $slider.addClass('active');
        } else {
          $cards.each(function (i) {
            $(this).toggleClass('reviews-text__card--hidden', i >= visible);
          });
          $btn.text(showMoreText);
          $slider.removeClass('active');
          $('html, body').animate({ scrollTop: $section.offset().top - 80 }, 300);
        }
      });
    } else {
      $slider.addClass('active');
    }
  }

  function removeGrid(sectionId) {
    var $section = $('#shopify-section-' + sectionId);
    var $slider = $section.find('.reviews-text__slider');
    var $cards = $section.find('.reviews-text__card');

    $slider.removeClass('reviews-text__slider--grid active');
    $cards.removeClass('reviews-text__card--hidden');
    $section.find('.reviews-text__nav .reviews-text__toggle').remove();
  }

  function initReadMoreVisibility(sectionId) {
    var $section = $('#shopify-section-' + sectionId);

    $section.find('.reviews-text__text-wrap').each(function () {
      var $wrap = $(this);
      var $clamp = $wrap.find('.reviews-text__text-clamp');
      var $btn = $wrap.find('.reviews-text__read-more-btn');
      var isClamped = $clamp[0].scrollHeight > $clamp[0].clientHeight;
      $btn.toggle(isClamped);
    });
  }

  function initScrollReveal(sectionId) {
    var $section = $('#shopify-section-' + sectionId);
    var $srElements = $section.find('.sr-hidden');
    if (!$srElements.length) return;

    if (window.innerWidth > MOBILE_BREAKPOINT && typeof ScrollReveal !== 'undefined') {
      $srElements.each(function (i, el) {
        ScrollReveal().reveal(el, {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 0 + (i * 40),
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          once: true
        });
      });
    } else {
      $srElements.each(function () {
        if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(this);
        $(this).css({ visibility: 'visible', opacity: 1 });
      });
    }
  }

  function applyLayout(sectionId) {
    if (isMobile()) {
      destroySwiper(sectionId);
      applyGrid(sectionId);
    } else {
      removeGrid(sectionId);
      initSwiper(sectionId);
    }
    initReadMoreVisibility(sectionId);
  }

  var instances = window.DeskReviewsText || {};

  $.each(instances, function (id, data) {
    applyLayout(data.sectionId);
    initScrollReveal(data.sectionId);
  });

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $.each(instances, function (id, data) {
        applyLayout(data.sectionId);
      });
    }, 150);
  });
});